import React, { Component, PureComponent } from 'react'
import VideoPlayer from 'react-video-js-player';
import axios from 'axios';
import $ from 'jquery';
import CustomAudioPlayer from './CustomAudioPlayer.js';
import CustomImagePlayer from './CustomImagePlayer.js';
import MyContext from '../../../common/MyContext';


var increaseView;
class VideoPlayerInRecordingPage extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            player: null,
            isIncreaseView: false,
            isIncreaseSimpleView: false,
            i: 0,
            isUpdate: true
        }
        this.countTime = this.countTime.bind(this);
    }

    // shouldComponentUpdate() {
    //     // if (this.props.recording != null) {
    //     //     return this.props.recording._id != nextProps.recording._id
    //     // }

    //     // return true;

    //     return this.state.isUpdate;
    // }

    componentWillUnmount() {
        clearInterval(increaseView)
    }

    onPlayerReady(player) {
        this.setState({
            player: player
        });

        var video = document.getElementsByTagName("video");
        video.item(0).setAttribute("playsinline", true);
        // video.item(0).setAttribute("controls", true);
        video.item(0).setAttribute("disablePictureInPicture", true);
    }

    onPlay(duration) {
        const { player } = this.state;
        const { user } = this.context;
        const { recording } = this.props;

        if (user == null || user === undefined) return;

        let json = {
            userId: user.facebookId,
            recordingId: recording._id,
            domain: window.location.hostname
        };

        // Chạy logic countTime cho tất cả các loại (video, audio, image)
        if (!this.state.isIncreaseView) {
            clearInterval(increaseView);
            
            const checkDuration = () => {
                let mediaDuration = null;
                
                // Với video: lấy duration từ player
                if (player && recording.recordingType === "VIDEO") {
                    if (player.duration() && !isNaN(player.duration()) && isFinite(player.duration())) {
                        mediaDuration = player.duration();
                    }
                }
                // Với audio: lấy duration từ audio element
                else if (recording.recordingType === "AUDIO") {
                    const audioElement = document.querySelector('audio');
                    if (audioElement && audioElement.duration && !isNaN(audioElement.duration) && isFinite(audioElement.duration)) {
                        mediaDuration = audioElement.duration;
                    }
                }
                // Với image: dùng duration mặc định 5 giây
                else if (recording.recordingType === "IMAGE") {
                    mediaDuration = 5; // 5 giây mặc định cho image
                }
                
                if (mediaDuration !== null) {
                    increaseView = setInterval(this.countTime, 1000, mediaDuration * 0.7, json);
                } else {
                    // Nếu chưa có duration, đợi 100ms rồi thử lại (cho video và audio)
                    if (recording.recordingType === "VIDEO" || recording.recordingType === "AUDIO") {
                        setTimeout(checkDuration, 100);
                    }
                }
            };
            
            checkDuration();
        }

        // Gọi API mỗi lần nhấn play (cho cả video, audio và image)
        axios.post(global.config.apiDomain + "/rest/increaseSimpleViewCounter", JSON.stringify(json), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {

        }, err => {
            console.log(err);
        });

    }

    onPause(duration) {
        clearInterval(increaseView);
    }

    componentWillReceiveProps(props) {
        clearInterval(increaseView)
        if (this.state.player) {
            const { player } = this.state;
            player.src(props.recording.vocalUrl);
            player.poster(props.recording.thumbnailImageUrl);
        }

        // Reset state cho tất cả các loại (video, audio, image)
        this.setState({
            isIncreaseView: false,
            i: 0
        })

    }


    countTime(time, json) {
        this.state.i++;
        if (this.state.i >= time) {
            clearInterval(increaseView);
            this.state.isIncreaseView = true;

            axios.post(global.config.apiDomain + "/rest/increaseViewCounter", JSON.stringify(json), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                // this.props.resetViewCounter();
            }, err => {
                console.log(err);
            })
        }
    }

    render() {
        const { recording } = this.props;

        let hideControls = [];
        if ($(window).width() < 576) {
            hideControls = ["volume"]
        }


        if (recording == null)
            return <></>

        this.state.isUpdate = false;

    if (recording.recordingType === "AUDIO") {
        return (
            <CustomAudioPlayer
                src={recording.vocalUrl}
                poster={recording.thumbnailImageUrl}
                title={recording.title}
                onPlay={this.onPlay.bind(this)}
                onPause={this.onPause.bind(this)}
            />
        )
    } else if(recording.recordingType == "IMAGE") {
        return (
            <CustomImagePlayer
                poster={recording.thumbnailImageUrl}
                title={recording.title}
                onPlay={this.onPlay.bind(this)}
            />
        )
    } else if (recording.recordingType === "VIDEO") {
        return (
            <VideoPlayer
                playsInline
                hideControls={hideControls}
                id="video-player"
                autoplay={true}
                onReady={this.onPlayerReady.bind(this)}
                controls={true}
                src={recording.vocalUrl}
                poster={recording.thumbnailImageUrl}
                className='vjs-16-9'
                onPlay={this.onPlay.bind(this)}
                onPause={this.onPause.bind(this)}
                type="video/mp4"
                preload="none"
            />
        )
    } else {
        return (
            <video 
                playsInline 
                hideControls={hideControls}
                id="video-player"
                autoplay={true}
                onReady={this.onPlayerReady.bind(this)}
                controls={true}
                src={recording.vocalUrl}
                poster={recording.thumbnailImageUrl}
                className='vjs-tech'
                onPlay={this.onPlay.bind(this)}
                onPause={this.onPause.bind(this)}
                type="video/mp4"
                preload="none"
            >
                <source autoplay={true} src={recording.vocalUrl} type="video/mp4" />
            </video>
        )
    }
    }
}

VideoPlayerInRecordingPage.contextType = MyContext;

export default VideoPlayerInRecordingPage;
